import styled from 'styled-components';

export const StyledSpacing = styled.div`
  width: 100%;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
`;
